'use strict';

import Page     from './Page';
import Resource from './Resource';
import Type     from './Type';

/**
 * @property {Resource[]} resources
 * @property {string}     name
 * @property {string[]}   scopes
 * @property {Type[]}     types
 */
class Api {

  /**
   * @param {string}    name
   * @param {Object[]}  resources
   * @param {Object[]}  types
   * @param {Object<string>}  pages
   * @param {string[]}  scopes
   */
  constructor ( { name, resources, types, scopes, pages } ) {
    this.name      = name;
    this.resources = resources.map(resourceData => new Resource(resourceData, this));
    this.types     = Object.entries(types).map(( [ name, typeData ] ) => new Type(name, typeData, this));
    this.scopes    = Array.from(new Set(scopes.flat()));
    this.pages     = Object.entries(pages).map(( [ title, content ] ) => new Page(title, content));
  }

  /**
   * Retrieves all endpoints
   *
   * @returns {Endpoint[]}
   */
  get endpoints () {
    return this.resources.reduce(( endpoints, resource ) => {
      return endpoints.concat(resource.endpoints);
    }, []);
  }

  /**
   * Finds a resource by its ID
   *
   * @param   {string}        id Resource ID
   * @returns {Resource|null}    Resource if found or null otherwise
   */
  findResourceById ( id ) {
    return this.resources.find(resource => resource.id === id);
  }

  /**
   * Finds an endpoint by its ID
   *
   * @param   {string}        id Endpoint ID
   * @returns {Endpoint|null}    Endpoint if found or null otherwise
   */
  findEndpointById ( id ) {
    return this.endpoints.find(endpoint => endpoint.id === id);
  }

  findPageBySlug ( slug ) {
    return this.pages.find(page => page.slug === slug);
  }
}

export default Api;
